function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import EditorPath from "./EditorPath";
import EditorLocale from "./EditorLocale";
import EditorStatus from "./EditorStatus";
import EditorAction from "./EditorAction";
import ButtonCollapsible from "../NavToolbar/ButtonCollapsible";
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "nowrap",
    maxWidth: "100%",
    width: "100%",
    minHeight: theme.spacing(8)
  },
  leading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "nowrap",
    maxWidth: "100%"
  },
  path: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "nowrap"
  },
  locale: {
    marginLeft: theme.spacing(1)
  },
  trailing: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      display: "none"
    }
  },
  status: {
    fontSize: "14px",
    margin: theme.spacing(1.5)
  },
  action: {
    fontSize: "14px"
  }
}));

const EditorHeader = (_ref) => {
  let collapsible = _ref.collapsible,
      expanded = _ref.expanded,
      onToggle = _ref.onToggle,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["collapsible", "expanded", "onToggle", "className"]);

  const classes = useStyles();
  return React.createElement("header", {
    className: className || classes.root
  }, React.createElement("div", {
    className: classes.leading
  }, React.createElement(EditorPath, _extends({}, props, {
    className: classes.path
  })), React.createElement(EditorLocale, _extends({}, props, {
    className: classes.locale
  })), collapsible && React.createElement(ButtonCollapsible, {
    expanded: expanded,
    onClick: onToggle
  })), React.createElement("div", {
    className: classes.trailing
  }, React.createElement(EditorStatus, _extends({}, props, {
    className: classes.status
  })), React.createElement(EditorAction, _extends({}, props, {
    className: classes.action
  }))));
};

EditorHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  status: PropTypes.string,
  statusLabel: PropTypes.string,
  statusDate: PropTypes.string,
  statusCode: PropTypes.string,
  statusMessage: PropTypes.string,
  untitled: PropTypes.string,
  title: PropTypes.string,
  parents: PropTypes.array,
  languages: PropTypes.array,
  currentLocale: PropTypes.string,
  onLocale: PropTypes.func,
  primaryAction: PropTypes.object
} : {};
export default EditorHeader;